import "./tournament-sponsorship-tier-remove.scss";
import { GSForm, GSSidePanelPage } from "golfstatus_react_components";
import { useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearNotifications,
  getTournamentSponsorshipTier,
  getTournamentSponsorshipTiers,
  removeTournamentSponsorshipTier,
  selectCurrentSponsorshipTier,
  selectLoading,
  selectSponsorshipTierList,
  selectSponsorshipTierNotifications,
} from "../../../reducers/sponsorshipTierSlice";
import { useEffect, useState } from "react";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  useNotificationBanner,
  useNotificationNavigation,
} from "../../../hooks/notificationHooks";
import { getRemoveTitle, removeItemForm } from "../../../forms/DeleteForm";
import TournamentSponsorshipTierItem from "./tournament-sponsorship-tier-item";
import { getTournamentSponsors as getSponsorsForListPage } from "../../../reducers/sponsorSlice";
import { selectTiersAvailable } from "../../../reducers/tournamentSlice";
import { getTierPaidMessage } from "../../../forms/SponsorshipTierForm";

const TournamentSponsorshipTierRemove = () => {
  const [isValid, setIsValid] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const match = useMatch(
    ":tournamentID/sponsors/sponsorship-tiers/:sponsorshipTierID/remove"
  );

  const tierLoading = useSelector(selectLoading);
  const currentSponsorshipTier = useSelector(selectCurrentSponsorshipTier);
  const tiersAvailable = useSelector(selectTiersAvailable);
  const sponsorshipTierNotifications = useSelector(
    selectSponsorshipTierNotifications
  );
  const tournamentSponsorshipTiers = useSelector(selectSponsorshipTierList);
  const defaultTier = tournamentSponsorshipTiers?.find(
    (t) => t.sponsorshipTierType === "default"
  );

  useEffect(() => {
    if (match?.params?.sponsorshipTierID) {
      dispatch(getTournamentSponsorshipTier(match?.params?.sponsorshipTierID));
    }
  }, [dispatch, match?.params?.sponsorshipTierID]);

  useEffect(() => {
    if (
      currentSponsorshipTier?.sponsorshipTierType === "technology" ||
      currentSponsorshipTier?.sponsorshipTierType === "default"
    ) {
      navigate(-1);
    }
  }, [currentSponsorshipTier?.sponsorshipTierType, navigate]);

  const timeoutAction = () => {
    dispatch(clearNotifications());
  };

  const leftNavigation = () => {
    timeoutAction();
    navigate(-1);
  };

  const getNavigation = () => {
    return {
      title: `Delete Sponsor Tier`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const getDisclaimer = () => {
    if (currentSponsorshipTier?.sponsorCount === 1) {
      return `Are you sure you want to remove this tier? The sponsor will not be deleted; it will be moved to ${defaultTier?.name}, the default tier. This cannot be undone.`;
    }
    if (currentSponsorshipTier?.sponsorCount > 1) {
      return `Are you sure you want to remove this tier? Sponsors will not be deleted; they will be moved to ${defaultTier?.name}, the default tier. This cannot be undone.`;
    }
  };

  const getContent = () => {
    if (!tiersAvailable && !tierLoading?.length > 0) {
      return getTierPaidMessage(getRemoveTitle("Delete Sponsor Tier"));
    }
    return (
      <GSForm
        formTitle={getRemoveTitle("Delete Sponsor Tier")}
        formSections={removeItemForm(
          "this tier",
          <TournamentSponsorshipTierItem {...currentSponsorshipTier} />,
          "remove",
          getDisclaimer()
        )}
      ></GSForm>
    );
  };

  useNotificationNavigation(
    "removed",
    sponsorshipTierNotifications,
    "../sponsorship-tiers"
  );

  const remove = async () => {
    setIsValid(false);
    if (currentSponsorshipTier) {
      await dispatch(
        removeTournamentSponsorshipTier(currentSponsorshipTier?.id)
      );
      dispatch(getSponsorsForListPage(match?.params?.tournamentID));
      dispatch(getTournamentSponsorshipTiers(match?.params?.tournamentID));
    }
  };

  const getDrawerActions = () => {
    let actions = [
      {
        name: "Delete",
        action: remove,
        isDisabled: !isValid,
        type: "red",
      },
      { name: "cancel", action: leftNavigation, type: "grey" },
    ];
    if (!tiersAvailable) {
      return (actions = []);
    }
    return actions;
  };

  const getDrawer = () => {
    return {
      actions: getDrawerActions(),
    };
  };

  const [bannerNotifications] = useNotificationBanner({
    notifications: sponsorshipTierNotifications,
    timeoutAction,
  });

  return (
    <tournament-sponsorship-tier-remove>
      <GSSidePanelPage
        loading={tierLoading?.length > 0}
        header={getNavigation()}
        banner={bannerNotifications}
        content={getContent()}
        drawer={getDrawer()}
      ></GSSidePanelPage>
    </tournament-sponsorship-tier-remove>
  );
};

export default TournamentSponsorshipTierRemove;
